import * as v from "valibot";

import { SUPPORTED_LOCALES } from "../locale";
import { rpcContract } from "../rpc";

export const setLanguagePreferenceRpcContract = rpcContract({
  name: "set-language-preference" as const,
  paramsSchema: v.object({
    language: v.picklist(SUPPORTED_LOCALES),
  }),
  resultSchema: v.object({
    language: v.picklist(SUPPORTED_LOCALES),
  }),
});

export type SetLanguagePreferenceParams = v.InferOutput<(typeof setLanguagePreferenceRpcContract)["paramsSchema"]>;
export type SetLanguagePreferenceResult = v.InferOutput<(typeof setLanguagePreferenceRpcContract)["resultSchema"]>;
